<script>
import XLSX from 'xlsx-js-style'

export default {
  name: 'FYUserFinalize',
  methods: {
    finalize() {
      this.$bvModal
        .msgBoxConfirm(
          'Are you sure you would like to continue? This process is irreversible.',
          {
            title: 'Please Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.graphql(
              /*GraphQL*/ `mutation finalizeMutation {
                finalizeFyUserMetrics(input: {clientMutationId: ""}) {
                  json
                }
              }`
            ).then(data => {
              // Main sheets
              let headerOrder = [
                'record_id',
                'user_facility',
                'research_statement',
                'project_title',
                'project_type',
                'funding_source',
                'last_name',
                'first_name',
                'email',
                'user_type',
                'position',
                'citizen',
                'citizen_country',
                'affiliation',
                'small_business',
                'address_1',
                'city',
                'state',
                'zipcode',
                'country',
                'orcid',
                'project_doi'
              ]
              let headerRow = [
                'Record Number',
                'User Facility',
                'Research Statement',
                'Project/Experiment Title',
                'Project/Experiment Type',
                'User Primary Source(s) of Project/Experiment Support',
                'User Last Name',
                'User First Name',
                'User Email',
                'User Type',
                'User Employment Level',
                'User is a U.S. Citizen',
                "User's Country of Citizenship",
                'Home Institution Name',
                'Home Institution is a Small Business',
                'Home Institution Street Address',
                'Home Institution City',
                'Home Institution State/Province/Territory',
                'Home Institution Zip Code',
                'Home Institution Country',
                'ORCID (optional)',
                'Project/Experiment DOI (optional)',
                'Home Institution ROR (optional)'
              ]
              let columnWidths = [
                { wch: 7 }, // Record Number
                { wch: 17 }, // User Facility
                { wch: 75 }, // Research Statement
                { wch: 75 }, // Project / Experiment Title
                { wch: 15 }, // Project / Experiment Type
                { wch: 50 }, // User Primary Source(s) of Project / Experiment Support
                { wch: 20 }, // User Last Name
                { wch: 20 }, // User First Name
                { wch: 25 }, // User Email
                { wch: 10 }, // User Type
                { wch: 35 }, // User Employment Level
                { wch: 10 }, // User is a U.S. Citizen
                { wch: 15 }, // User's Country of Citizenship
                { wch: 40 }, // Home Institution Name
                { wch: 16 }, // Home Institution is a Small Business
                { wch: 40 }, // Home Institution Street Address
                { wch: 20 }, // Home Institution City
                { wch: 20 }, // Home Institution State / Province / Territory
                { wch: 20 }, // Home Institution Zip Code
                { wch: 15 }, // Home Institution Country
                { wch: 40 }, // ORCID
                { wch: 40 }, //'Project/Experiment DOI (optional)',
                { wch: 40 } // 'Home Institution ROR (optional)'
              ]

              function buildSheet(rows) {
                let thisHeaderRow = []
                let thisHeaderOrder = []
                let thisColumnWidths = []
                for (let h = 0; h < headerRow.length; h++) {
                  if (Object.keys(rows[0]).includes(headerOrder[h])) {
                    thisHeaderRow.push(headerRow[h])
                    thisHeaderOrder.push(headerOrder[h])
                    thisColumnWidths.push(columnWidths[h])
                  }
                }
                const ws = XLSX.utils.aoa_to_sheet([thisHeaderRow])
                XLSX.utils.sheet_add_json(ws, rows, {
                  header: thisHeaderOrder,
                  skipHeader: true,
                  origin: -1
                })
                ws['!cols'] = thisColumnWidths
                ws['!rows'] = [{ hpt: 30 }] // make first row taller
                for (let c = 0; c < thisHeaderRow.length; c++) {
                  ws[XLSX.utils.encode_cell({ r: 0, c })].s = {
                    alignment: { wrapText: true },
                    fill: { fgColor: { rgb: 'FFFF00' } }
                  }
                }
                return ws
              }

              // Build and download the book
              const wb = XLSX.utils.book_new()
              XLSX.utils.book_append_sheet(
                wb,
                buildSheet(data.finalizeFyUserMetrics.json.all),
                'All User Projects'
              )
              XLSX.utils.book_append_sheet(
                wb,
                buildSheet(data.finalizeFyUserMetrics.json.unique),
                'Unique User Projects'
              )
              headerOrder = [
                'affiliation',
                'last_name',
                'first_name',
                'orcid',
                'email'
              ]
              headerRow = [
                'Home Institution Name',
                'User Last Name',
                'User First Name',
                'ORCID',
                'User Email'
              ]
              columnWidths = [
                { wch: 40 }, // Home Institution Name
                { wch: 20 }, // User Last Name
                { wch: 20 }, // User First Name
                { wch: 20 }, // ORCID
                { wch: 25 } // User Email
              ]
              XLSX.utils.book_append_sheet(
                wb,
                buildSheet(
                  data.finalizeFyUserMetrics.json.unique.map(row => ({
                    affiliation: row.affiliation,
                    last_name: row.last_name,
                    first_name: row.first_name,
                    orcid: row.orcid,
                    email: row.email
                  }))
                ),
                'Unique Users'
              )
              XLSX.writeFile(
                wb,
                `FY${this.$store.state.lastFiscalYear}_User_Metrics.xlsx`
              )

              // Category sheets
              function buildCategorySheet(
                header,
                rows,
                columnOrder,
                widths,
                includeTotal,
                specialNotes
              ) {
                const ws = XLSX.utils.aoa_to_sheet([header])
                XLSX.utils.sheet_add_json(ws, rows, {
                  header: columnOrder,
                  skipHeader: true,
                  origin: -1
                })
                ws['!cols'] = widths.map(width => ({ wch: width }))
                if (includeTotal) {
                  const totalRow =
                    typeof includeTotal == 'object'
                      ? includeTotal
                      : header.length == 3
                      ? [
                          '',
                          'Total',
                          rows.reduce(
                            (partialSum, r) =>
                              partialSum + r[columnOrder.at(-1)],
                            0
                          )
                        ]
                      : [
                          'Total',
                          rows.reduce(
                            (partialSum, r) =>
                              partialSum + r[columnOrder.at(-1)],
                            0
                          )
                        ]
                  XLSX.utils.sheet_add_aoa(ws, [[], totalRow], {
                    origin: -1
                  })
                }
                if (specialNotes) {
                  XLSX.utils.sheet_add_aoa(ws, [[], [specialNotes]], {
                    origin: -1
                  })
                }
                return ws
              }

              // Build and download the category book
              const cateogryWb = XLSX.utils.book_new()
              XLSX.utils.book_append_sheet(
                cateogryWb,
                buildCategorySheet(
                  ['Country Code', 'Country Name', 'Num Users'],
                  data.finalizeFyUserMetrics.json.countries,
                  ['country_code', 'country_name', 'num_users'],
                  [12, 20, 10],
                  true
                ),
                'Users by Country'
              )
              XLSX.utils.book_append_sheet(
                cateogryWb,
                buildCategorySheet(
                  ['Type of Business', 'Num Users'],
                  data.finalizeFyUserMetrics.json.types,
                  ['type_of_business', 'num_users'],
                  [30, 10],
                  true
                ),
                'Users by Type'
              )
              XLSX.utils.book_append_sheet(
                cateogryWb,
                buildCategorySheet(
                  ['User Type', 'Distinct Users', 'Total Users'],
                  data.finalizeFyUserMetrics.json.usage,
                  ['user_type', 'distinct_users', 'total_users'],
                  [10, 10, 10],
                  [
                    'Total',
                    data.finalizeFyUserMetrics.json.usage.reduce(
                      (partialSum, r) => partialSum + r.distinct_users,
                      0
                    ),
                    data.finalizeFyUserMetrics.json.usage.reduce(
                      (partialSum, r) => partialSum + r.total_users,
                      0
                    )
                  ],
                  'Note: Total users counts users under multiple sources if they have multiple projects with different sources'
                ),
                'Facility Usage'
              )
              XLSX.utils.book_append_sheet(
                cateogryWb,
                buildCategorySheet(
                  ['Primary Observatory', 'Num Campaigns'],
                  data.finalizeFyUserMetrics.json.campaigns,
                  ['primary_observatory', 'num_campaigns'],
                  [18, 15],
                  true
                ),
                'Campaigns by Observatory'
              )
              XLSX.utils.book_append_sheet(
                cateogryWb,
                buildCategorySheet(
                  ['Category', 'Count'],
                  data.finalizeFyUserMetrics.json.other,
                  ['category', 'count'],
                  [40, 10]
                ),
                'Other Info'
              )
              XLSX.writeFile(
                cateogryWb,
                `FY${this.$store.state.lastFiscalYear}_User_Metrics_Categories.xlsx`
              )
            })
          }
        })
    }
  }
}
</script>

<template>
  <div class="p-4">
    <p>
      This will remove any existing entries from the final fiscal year user
      metrics table for the the FY{{ $store.state.lastFiscalYear }} data, copy
      all non-excluded entries from the FY User Metrics into the final fiscal
      year user metrics table, then download the spreadsheets to turn in to DOE
      and the ARM Communications Team.
    </p>
    <p>
      <i><strong>NOTE:</strong> This can not be undone</i>
    </p>
    <br />
    <br />
    <b-button @click="finalize">
      Finalize FY{{ $store.state.lastFiscalYear }} Metrics
    </b-button>
  </div>
</template>
